import React, { useState } from 'react';
import { Card, Button, Alert, Spinner } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { authService } from '../services/authService';

// Admins sign in via the corporate workforce Entra ID tenant (Authorization Code + PKCE redirect
// to the hosted login page) — not an in-app credential form. `message` carries an optional denial
// reason (e.g. authenticated but lacking the waive-admin role).
function LoginScreen({ message }) {
    const [error, setError] = useState(message || '');
    const [loading, setLoading] = useState(false);

    const handleSignIn = async () => {
        setError('');
        setLoading(true);
        try {
            await authService.login(); // redirects away to the hosted login page
        } catch {
            setError('Unable to start sign-in. Please try again.');
            setLoading(false);
        }
    };

    return (
        <div className="login-screen">
            <div className="login-container">
                <Card className="login-card">
                    <div className="login-header">
                        <div className="login-logo">
                            <span className="logo-accent">W</span>aive
                        </div>
                        <div className="login-badge">Admin Portal</div>
                    </div>

                    <div className="login-body">
                        <h2 className="login-title">
                            <FontAwesomeIcon icon="lock" className="me-2" />
                            Administrator Sign In
                        </h2>

                        {error && (
                            <Alert variant="danger" className="mb-4">
                                <FontAwesomeIcon icon="exclamation-circle" className="me-2" />
                                {error}
                            </Alert>
                        )}

                        <p className="text-muted mb-4">
                            Sign in with your Waive corporate account. Access requires the
                            <strong> waive-admin </strong> role.
                        </p>

                        <Button
                            type="button"
                            className="login-btn w-100"
                            onClick={handleSignIn}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Redirecting…
                                </>
                            ) : (
                                <>
                                    <FontAwesomeIcon icon="sign-in-alt" className="me-2" />
                                    Sign in with Microsoft
                                </>
                            )}
                        </Button>
                    </div>

                    <div className="login-footer">
                        <FontAwesomeIcon icon="shield-alt" className="me-2" />
                        Waive platform administration — authorised access only
                    </div>
                </Card>
            </div>
        </div>
    );
}

export default LoginScreen;
